import { NoRowsOverlay } from '@/components/table/DataGridComponents/NoRowsOverlay';

const ContactsNoRowsOverlay = () => <NoRowsOverlay objectType='relationshipContact' />;

export default ContactsNoRowsOverlay;
